// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RecentUserStatistics_header__xOlxi {
    margin-bottom: 25px;
}

.RecentUserStatistics_title__Tv23U {
    font-size: 30px;
}

.RecentUserStatistics_chart_box_main__18HPo {

}

.RecentUserStatistics_chart_box_header__3zSIc {

}

.RecentUserStatistics_chart_box_item__\\+NGiJ {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 400px;
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/components/RecentUserStatistics/index.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,aAAa;AACjB","sourcesContent":[".header {\n    margin-bottom: 25px;\n}\n\n.title {\n    font-size: 30px;\n}\n\n.chart_box_main {\n\n}\n\n.chart_box_header {\n\n}\n\n.chart_box_item {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 400px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `RecentUserStatistics_header__xOlxi`,
	"title": `RecentUserStatistics_title__Tv23U`,
	"chart_box_main": `RecentUserStatistics_chart_box_main__18HPo`,
	"chart_box_header": `RecentUserStatistics_chart_box_header__3zSIc`,
	"chart_box_item": `RecentUserStatistics_chart_box_item__+NGiJ`
};
export default ___CSS_LOADER_EXPORT___;
